var map = {
	"./components/App.vue": [
		122
	],
	"./components/chartjs/Bar.vue": [
		644,
		68
	],
	"./components/chartjs/Line.vue": [
		645,
		67
	],
	"./components/global/Action.vue": [
		278
	],
	"./components/global/Bubble.vue": [
		279
	],
	"./components/global/ButtonBack.vue": [
		280
	],
	"./components/global/Calendar.vue": [
		281
	],
	"./components/global/ChannelList.vue": [
		282
	],
	"./components/global/ChannelListGroup.vue": [
		283
	],
	"./components/global/ChannelListSingle.vue": [
		285
	],
	"./components/global/Chat.vue": [
		286
	],
	"./components/global/ChatBubble.vue": [
		287
	],
	"./components/global/Chatbox.vue": [
		82
	],
	"./components/global/Confirm.vue": [
		126
	],
	"./components/global/Container.vue": [
		288
	],
	"./components/global/Dates.vue": [
		289
	],
	"./components/global/Dropdown.vue": [
		290
	],
	"./components/global/Error.vue": [
		291
	],
	"./components/global/Flash.vue": [
		124
	],
	"./components/global/FooterBar.vue": [
		292
	],
	"./components/global/Gravatar.vue": [
		293
	],
	"./components/global/GravatarGroup.vue": [
		294
	],
	"./components/global/Icon.vue": [
		295
	],
	"./components/global/ItemChatbox.vue": [
		296
	],
	"./components/global/Lesson.vue": [
		130
	],
	"./components/global/Loader.vue": [
		127
	],
	"./components/global/LoginAside.vue": [
		137
	],
	"./components/global/MainContent.vue": [
		297
	],
	"./components/global/MainHeader.vue": [
		134
	],
	"./components/global/Modal.vue": [
		123
	],
	"./components/global/Notes.vue": [
		298
	],
	"./components/global/Notification.vue": [
		128
	],
	"./components/global/Numeric.vue": [
		299
	],
	"./components/global/Percents.vue": [
		300
	],
	"./components/global/Pikaday.vue": [
		301
	],
	"./components/global/Presence.vue": [
		646,
		223
	],
	"./components/global/Profile.vue": [
		302
	],
	"./components/global/Rangepicker.vue": [
		304
	],
	"./components/global/Search.vue": [
		305
	],
	"./components/global/Selection.vue": [
		306
	],
	"./components/global/Sidebar.vue": [
		307
	],
	"./components/global/SubHeader.vue": [
		308
	],
	"./components/global/Tab.vue": [
		309
	],
	"./components/global/Tabs.vue": [
		310
	],
	"./components/global/Timeframe.vue": [
		311
	],
	"./components/global/Timepicker.vue": [
		312
	],
	"./components/global/Toolbox.vue": [
		313
	],
	"./components/global/Tools.vue": [
		314
	],
	"./components/global/Tooltip.vue": [
		131
	],
	"./components/global/University.vue": [
		129
	],
	"./components/global/Widget.vue": [
		125
	],
	"./components/global/dashboard/Card.vue": [
		329
	],
	"./components/global/dashboard/Filter.vue": [
		641,
		222
	],
	"./components/global/dashboard/OpenApplications.vue": [
		655,
		35
	],
	"./components/global/dashboard/OpenItems.vue": [
		656,
		66
	],
	"./components/global/tools/Conflicts.vue": [
		317
	],
	"./components/global/tools/Duty.vue": [
		320
	],
	"./components/global/tools/Employee.vue": [
		325
	],
	"./components/global/tools/Flags.vue": [
		324
	],
	"./components/global/tools/Internal.vue": [
		316
	],
	"./components/global/tools/NewDuty.vue": [
		327
	],
	"./components/global/tools/NewShift.vue": [
		326
	],
	"./components/global/tools/NewUser.vue": [
		328
	],
	"./components/global/tools/Notes.vue": [
		315
	],
	"./components/global/tools/Shift.vue": [
		319
	],
	"./components/global/tools/Sick.vue": [
		323
	],
	"./components/global/tools/Tags.vue": [
		322
	],
	"./components/global/tools/Times.vue": [
		318
	],
	"./components/global/tools/User.vue": [
		321
	],
	"./components/modals/AbsenceRegistration.vue": [
		657,
		82
	],
	"./components/modules/Navigation.vue": [
		135
	],
	"./components/modules/SubNavigation.vue": [
		658,
		221
	],
	"./components/widgets/addContract.vue": [
		757,
		123
	],
	"./components/widgets/addHours.vue": [
		758,
		220
	],
	"./components/widgets/assignLocations.vue": [
		759,
		81
	],
	"./components/widgets/changeEmail.vue": [
		760,
		219
	],
	"./components/widgets/changePassword.vue": [
		761,
		218
	],
	"./components/widgets/chatParticipants.vue": [
		762,
		217
	],
	"./components/widgets/checkin.vue": [
		763,
		216
	],
	"./components/widgets/checkins.vue": [
		764,
		215
	],
	"./components/widgets/clients.vue": [
		765,
		80
	],
	"./components/widgets/contractTemplate.vue": [
		766,
		79
	],
	"./components/widgets/contracts.vue": [
		767,
		78
	],
	"./components/widgets/costs.vue": [
		768,
		214
	],
	"./components/widgets/defaultAvailability.vue": [
		769,
		213
	],
	"./components/widgets/denyHours.vue": [
		770,
		212
	],
	"./components/widgets/duties.vue": [
		771,
		122
	],
	"./components/widgets/employeeNumber.vue": [
		772,
		211
	],
	"./components/widgets/employees.vue": [
		773,
		210
	],
	"./components/widgets/employeesEdit.vue": [
		774,
		121
	],
	"./components/widgets/expenses.vue": [
		775,
		209
	],
	"./components/widgets/holidays.vue": [
		776,
		208
	],
	"./components/widgets/launchDashboard.vue": [
		777,
		207
	],
	"./components/widgets/location.vue": [
		778,
		206
	],
	"./components/widgets/locations.vue": [
		779,
		205
	],
	"./components/widgets/newChat.vue": [
		780,
		204
	],
	"./components/widgets/planningMemberships.vue": [
		781,
		203
	],
	"./components/widgets/planningResources.vue": [
		782,
		202
	],
	"./components/widgets/plannings.vue": [
		783,
		201
	],
	"./components/widgets/premiums.vue": [
		784,
		200
	],
	"./components/widgets/profileLocations.vue": [
		785,
		199
	],
	"./components/widgets/projects.vue": [
		786,
		198
	],
	"./components/widgets/rates.vue": [
		787,
		197
	],
	"./components/widgets/report.vue": [
		788,
		120
	],
	"./components/widgets/resources.vue": [
		789,
		196
	],
	"./components/widgets/revenues.vue": [
		790,
		119
	],
	"./components/widgets/salary.vue": [
		791,
		195
	],
	"./components/widgets/shifts.vue": [
		792,
		40
	],
	"./components/widgets/signature.vue": [
		793,
		64
	],
	"./components/widgets/switcher.vue": [
		794,
		194
	],
	"./components/widgets/tags.vue": [
		795,
		193
	],
	"./components/widgets/timechooser.vue": [
		796,
		192
	],
	"./components/widgets/userProfile.vue": [
		797,
		77
	],
	"./pages/absences/Page.vue": [
		798,
		6
	],
	"./pages/absences/components/Sidebar.vue": [
		659,
		118
	],
	"./pages/availability/Page.vue": [
		799,
		7
	],
	"./pages/availability/components/Sidebar.vue": [
		660,
		117
	],
	"./pages/availability/components/SubHeader.vue": [
		661,
		116
	],
	"./pages/availability/planner/Availability.vue": [
		662,
		39
	],
	"./pages/availability/planner/Cell.new.vue": [
		800,
		115
	],
	"./pages/availability/planner/Cell.vue": [
		647,
		114
	],
	"./pages/availability/user/Availability.vue": [
		663,
		38
	],
	"./pages/availability/user/Cell.vue": [
		648,
		113
	],
	"./pages/balances/details/Page.vue": [
		801,
		33
	],
	"./pages/balances/details/components/Sidebar.vue": [
		664,
		191
	],
	"./pages/balances/details/components/SubHeader.vue": [
		665,
		190
	],
	"./pages/balances/overview/Page.vue": [
		802,
		32
	],
	"./pages/balances/overview/components/Sidebar.vue": [
		666,
		189
	],
	"./pages/balances/overview/components/SubHeader.vue": [
		667,
		188
	],
	"./pages/chats/details/Page.vue": [
		803,
		63
	],
	"./pages/chats/details/components/SubHeader.vue": [
		668,
		187
	],
	"./pages/chats/overview/Page.vue": [
		804,
		62
	],
	"./pages/chats/overview/components/SubHeader.vue": [
		669,
		186
	],
	"./pages/checkins/Page.vue": [
		805,
		11
	],
	"./pages/checkins/components/CheckinTime.vue": [
		672,
		185
	],
	"./pages/checkins/components/Item.vue": [
		649,
		76
	],
	"./pages/checkins/components/Sidebar.vue": [
		671,
		34
	],
	"./pages/checkins/components/SubHeader.vue": [
		670,
		184
	],
	"./pages/clients/overview/Page.vue": [
		806,
		26
	],
	"./pages/clients/overview/components/Sidebar.vue": [
		673,
		112
	],
	"./pages/clients/overview/components/SubHeader.vue": [
		674,
		183
	],
	"./pages/company/Page.vue": [
		807,
		20
	],
	"./pages/contacts/Page.vue": [
		808,
		61
	],
	"./pages/contacts/components/SubHeader.vue": [
		675,
		182
	],
	"./pages/dashboard/Hour.vue": [
		676,
		111
	],
	"./pages/dashboard/Page.vue": [
		809,
		27
	],
	"./pages/demo/Page.vue": [
		810,
		75
	],
	"./pages/documents/detail/Page.vue": [
		811,
		25
	],
	"./pages/documents/detail/components/Sidebar.vue": [
		678,
		110
	],
	"./pages/documents/detail/components/SubHeader.vue": [
		677,
		109
	],
	"./pages/documents/overview/Page.vue": [
		812,
		37
	],
	"./pages/documents/overview/components/Sidebar.vue": [
		813,
		181
	],
	"./pages/documents/overview/components/SubHeader.vue": [
		679,
		180
	],
	"./pages/example.vue": [
		814,
		74
	],
	"./pages/hours/Page.vue": [
		815,
		10
	],
	"./pages/hours/components/HoursItem.vue": [
		682,
		179
	],
	"./pages/hours/components/Item.vue": [
		816,
		178
	],
	"./pages/hours/components/Sidebar.vue": [
		680,
		31
	],
	"./pages/hours/components/SubHeader.vue": [
		681,
		177
	],
	"./pages/hours/components/tab/biller.vue": [
		650,
		176
	],
	"./pages/hours/components/tab/supervisor.vue": [
		651,
		175
	],
	"./pages/invoice/Page.vue": [
		817,
		174
	],
	"./pages/lists/Page.vue": [
		818,
		2
	],
	"./pages/lists/components/Sidebar.vue": [
		683,
		108
	],
	"./pages/lists/components/SubHeader.vue": [
		684,
		173
	],
	"./pages/log/Page.vue": [
		819,
		24
	],
	"./pages/log/components/Sidebar.vue": [
		685,
		107
	],
	"./pages/log/components/SubHeader.vue": [
		686,
		172
	],
	"./pages/login/2fa-setup/Page.vue": [
		820,
		106
	],
	"./pages/login/2fa-verify/Page.vue": [
		821,
		105
	],
	"./pages/login/accept/Page.vue": [
		822,
		171
	],
	"./pages/login/confirm/Page.vue": [
		823,
		170
	],
	"./pages/login/confirmation/Page.vue": [
		824,
		169
	],
	"./pages/login/password/Page.vue": [
		825,
		168
	],
	"./pages/login/reset/Page.vue": [
		826,
		167
	],
	"./pages/login/signin/Page.vue": [
		827,
		104
	],
	"./pages/login/signup/Page.vue": [
		828,
		166
	],
	"./pages/modules/Page.vue": [
		829,
		16
	],
	"./pages/modules/components/Module.vue": [
		687,
		165
	],
	"./pages/modules/components/Sidebar.vue": [
		688,
		164
	],
	"./pages/modules/components/SubHeader.vue": [
		689,
		163
	],
	"./pages/notifications/Page.vue": [
		830,
		30
	],
	"./pages/notifications/components/Sidebar.vue": [
		690,
		162
	],
	"./pages/notifications/components/SubHeader.vue": [
		691,
		161
	],
	"./pages/overview/Page.vue": [
		831,
		3
	],
	"./pages/overview/components/Sidebar.vue": [
		693,
		160
	],
	"./pages/overview/components/SubHeader.vue": [
		692,
		159
	],
	"./pages/payslips/Page.vue": [
		832,
		19
	],
	"./pages/payslips/components/Sidebar.vue": [
		694,
		73
	],
	"./pages/payslips/components/SubHeader.vue": [
		695,
		158
	],
	"./pages/planning/Page.vue": [
		833,
		1
	],
	"./pages/planning/components/Assigned.vue": [
		700,
		60
	],
	"./pages/planning/components/Availability.vue": [
		702,
		157
	],
	"./pages/planning/components/Calculations.vue": [
		696,
		156
	],
	"./pages/planning/components/Copied.vue": [
		699,
		59
	],
	"./pages/planning/components/Item.vue": [
		639,
		155
	],
	"./pages/planning/components/Placeholder.vue": [
		701,
		58
	],
	"./pages/planning/components/Sidebar.vue": [
		697,
		154
	],
	"./pages/planning/components/SubHeader.vue": [
		698,
		103
	],
	"./pages/planning/components/Weather.vue": [
		703,
		153
	],
	"./pages/plannings/Page.vue": [
		834,
		23
	],
	"./pages/plannings/components/Sidebar.vue": [
		704,
		102
	],
	"./pages/plannings/components/SubHeader.vue": [
		705,
		152
	],
	"./pages/profile/Page.vue": [
		835,
		29
	],
	"./pages/profile/components/Sidebar.vue": [
		706,
		151
	],
	"./pages/profile/components/SubHeader.vue": [
		707,
		150
	],
	"./pages/register/Page.vue": [
		836,
		149
	],
	"./pages/reports/Page.vue": [
		837,
		9
	],
	"./pages/reports/components/Item.vue": [
		652,
		101
	],
	"./pages/reports/components/Report.vue": [
		710,
		36
	],
	"./pages/reports/components/Sidebar.vue": [
		709,
		100
	],
	"./pages/reports/components/SubHeader.vue": [
		708,
		99
	],
	"./pages/resources/edit/Page.vue": [
		838,
		22
	],
	"./pages/resources/edit/components/Sidebar.vue": [
		712,
		98
	],
	"./pages/resources/edit/components/SubHeader.vue": [
		711,
		148
	],
	"./pages/resources/overview/Page.vue": [
		839,
		21
	],
	"./pages/resources/overview/components/Sidebar.vue": [
		714,
		97
	],
	"./pages/resources/overview/components/SubHeader.vue": [
		713,
		147
	],
	"./pages/roster/Page.vue": [
		840,
		5
	],
	"./pages/roster/components/Content.vue": [
		715,
		12
	],
	"./pages/roster/components/Day.vue": [
		642,
		18
	],
	"./pages/roster/components/Detail.vue": [
		640,
		72
	],
	"./pages/roster/components/Item.vue": [
		643,
		71
	],
	"./pages/roster/components/Sidebar.vue": [
		716,
		70
	],
	"./pages/roster/components/SubHeader.vue": [
		717,
		69
	],
	"./pages/settings/Page.vue": [
		841,
		65
	],
	"./pages/settings/advanced/Page.vue": [
		842,
		57
	],
	"./pages/settings/advanced/components/SubHeader.vue": [
		718,
		146
	],
	"./pages/settings/availability/Page.vue": [
		843,
		56
	],
	"./pages/settings/availability/components/SubHeader.vue": [
		719,
		145
	],
	"./pages/settings/checkin/Page.vue": [
		844,
		55
	],
	"./pages/settings/checkin/components/SubHeader.vue": [
		720,
		144
	],
	"./pages/settings/contracts/Page.vue": [
		845,
		54
	],
	"./pages/settings/contracts/components/SubHeader.vue": [
		721,
		143
	],
	"./pages/settings/costs/Page.vue": [
		846,
		53
	],
	"./pages/settings/costs/components/SubHeader.vue": [
		722,
		142
	],
	"./pages/settings/duties/Page.vue": [
		847,
		52
	],
	"./pages/settings/duties/components/SubHeader.vue": [
		723,
		141
	],
	"./pages/settings/expenses/Page.vue": [
		848,
		51
	],
	"./pages/settings/expenses/components/SubHeader.vue": [
		724,
		140
	],
	"./pages/settings/general/Page.vue": [
		849,
		50
	],
	"./pages/settings/general/components/SubHeader.vue": [
		725,
		139
	],
	"./pages/settings/holidays/Page.vue": [
		850,
		49
	],
	"./pages/settings/holidays/components/SubHeader.vue": [
		726,
		138
	],
	"./pages/settings/locations/Page.vue": [
		851,
		48
	],
	"./pages/settings/locations/components/SubHeader.vue": [
		727,
		137
	],
	"./pages/settings/premiums/Page.vue": [
		852,
		47
	],
	"./pages/settings/premiums/components/SubHeader.vue": [
		728,
		136
	],
	"./pages/settings/rates/Page.vue": [
		853,
		46
	],
	"./pages/settings/rates/components/SubHeader.vue": [
		729,
		135
	],
	"./pages/settings/shifts/Page.vue": [
		854,
		45
	],
	"./pages/settings/shifts/components/SubHeader.vue": [
		730,
		134
	],
	"./pages/settings/tags/Page.vue": [
		855,
		44
	],
	"./pages/settings/tags/components/SubHeader.vue": [
		731,
		133
	],
	"./pages/setup/Page.vue": [
		856,
		132
	],
	"./pages/statistics/Page.vue": [
		857,
		4
	],
	"./pages/statistics/components/Sidebar.vue": [
		735,
		96
	],
	"./pages/statistics/components/SubHeader.vue": [
		734,
		131
	],
	"./pages/statistics/components/TabDetails.vue": [
		733,
		43
	],
	"./pages/statistics/components/TabOverview.vue": [
		732,
		13
	],
	"./pages/subscription/Page.vue": [
		858,
		28
	],
	"./pages/subscription/components/Sidebar.vue": [
		736,
		130
	],
	"./pages/subscription/components/SubHeader.vue": [
		737,
		129
	],
	"./pages/team/edit/Page.vue": [
		859,
		0
	],
	"./pages/team/edit/components/SubHeader.vue": [
		738,
		128
	],
	"./pages/team/edit/sidebars/absence.vue": [
		752,
		95
	],
	"./pages/team/edit/sidebars/contract.vue": [
		748,
		42
	],
	"./pages/team/edit/sidebars/dossier.vue": [
		750,
		94
	],
	"./pages/team/edit/sidebars/payslips.vue": [
		751,
		93
	],
	"./pages/team/edit/sidebars/profile.vue": [
		746,
		92
	],
	"./pages/team/edit/sidebars/salary.vue": [
		749,
		91
	],
	"./pages/team/edit/sidebars/settings.vue": [
		747,
		90
	],
	"./pages/team/edit/tabs/Absence.vue": [
		745,
		17
	],
	"./pages/team/edit/tabs/Contract.vue": [
		740,
		89
	],
	"./pages/team/edit/tabs/Dossier.vue": [
		743,
		88
	],
	"./pages/team/edit/tabs/Payslips.vue": [
		744,
		87
	],
	"./pages/team/edit/tabs/Profile.vue": [
		739,
		86
	],
	"./pages/team/edit/tabs/Salary.vue": [
		741,
		85
	],
	"./pages/team/edit/tabs/Settings.vue": [
		742,
		84
	],
	"./pages/team/overview/Page.vue": [
		860,
		15
	],
	"./pages/team/overview/components/Sidebar.vue": [
		754,
		83
	],
	"./pages/team/overview/components/SubHeader.vue": [
		753,
		127
	],
	"./pages/today/Page.vue": [
		861,
		8
	],
	"./pages/today/components/Sidebar.vue": [
		756,
		14
	],
	"./pages/today/components/SubHeader.vue": [
		755,
		126
	],
	"./pages/today/components/tab/employees.vue": [
		653,
		125
	],
	"./pages/today/components/tab/locations.vue": [
		654,
		41
	],
	"./pages/welcome/Page.vue": [
		862,
		124
	],
	"./templates/Backend.vue": [
		133
	],
	"./templates/Empty.vue": [
		132
	],
	"./templates/Frontend.vue": [
		136
	],
	"./templates/Invoice.vue": [
		139
	],
	"./templates/Wizard.vue": [
		138
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 456;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/js lazy ^.*\.vue$
// module id = 456
// module chunks = 225